import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-empty-box',
  templateUrl: './empty-box.component.html',
  styleUrls: ['./empty-box.component.scss']
})
export class EmptyBoxComponent implements OnInit {
  @Input() title = 'موجودیتی';
  constructor() { }
  ngOnInit(): void {
  }
}
